"use strict";

var primitives = require('./primitives');
module.exports = {
  primary: primitives['yellow-100'],
  'status-warning': primitives['yellow-100'],
  'primary-hover': primitives['yellow-200'],
  'status-warning-hover': primitives['yellow-200'],
  'primary-active': primitives['yellow-300'],
  'status-warning-active': primitives['yellow-300'],
  'whiteblock-hover': primitives['gray-100'],
  'card-secondary': primitives['gray-100'],
  border: primitives['gray-200'],
  'border-dark': primitives['gray-300'],
  'border-darker': primitives['gray-400'],
  status: primitives['gray-400'],
  'text-alternate': primitives['gray-400'],
  'status-hover': primitives['gray-500'],
  'textfield-placeholder': primitives['gray-500'],
  'border-focus': primitives['gray-600'],
  'textfield-placeholder-hover': primitives['gray-600'],
  'status-active': primitives['gray-600'],
  textfield: primitives['lightBlue-100'],
  secondary: primitives['lightBlue-100'],
  'textfield-hover': primitives['lightBlue-200'],
  'secondary-hover': primitives['lightBlue-200'],
  'secondary-active': primitives['lightBlue-300'],
  'blank-black': primitives['black-300'],
  'blank-white': primitives.white,
  'card-primary': primitives.white,
  'text-inverse': primitives.white,
  'outline-border': primitives['blue-100'],
  link: primitives['blue-100'],
  'outline-border-hover': primitives['blue-200'],
  'link-hover': primitives['blue-200'],
  'outline-border-active': primitives['blue-300'],
  'link-active': primitives['blue-300'],
  'status-success': primitives['green-100'],
  'status-success-hover': primitives['green-200'],
  'status-success-active': primitives['green-300'],
  'status-error': primitives['red-100'],
  'status-error-hover': primitives['red-200'],
  'status-error-active': primitives['red-300'],
  'true-black': primitives['black-400']
};